import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Testimonials.css";

// UAE-based testimonials with images
const testimonials = [
  { 
    name: "Ahmed Al Nahyan", 
    text: "SR Ads boosted our Dubai restaurant sales with amazing TikTok ads!", 
    image: require("../Assets/About/3.jpg") 
  },
  { 
    name: "Fatima Al Suwaidi", 
    text: "Our e-commerce brand saw 3x ROI from Facebook campaigns. Highly recommended!", 
    image: require("../Assets/About/5.jpg") 
  },
  { 
    name: "Hassan Al Mansoori", 
    text: "Google Ads strategy was perfect. We got quality leads within days.", 
    image: require("../Assets/About/6.jpg") 
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials reveal">
      <h2>What Our Clients Say</h2>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
      >
        {testimonials.map((t, i) => (
          <SwiperSlide key={i}>
            <div className="testimonial-card">
              <img src={t.image} alt={t.name} className="testimonial-image" />
              <p>"{t.text}"</p>
              <h4>- {t.name}</h4>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
